// 各种跳转到端外页面或是小程序的逻辑
import { getAdapter } from 'lib/_common/msdkAdapter';
import { report } from 'lib/utils/dataReport';
import userOrderService from 'lib/services/userOrderService';
import { config } from 'lib/config';
import { currentUrlParams } from './url';
import session from './session';

const adapter = getAdapter();

export function gotoBenefitMiniProgram(type) {
  const TYPE_MAP = {
    ORDER: 'submitrem', // （订购申请提交中弹窗）
    LOT: 'lotresultpop', // (抽奖结果弹窗）
    NORMAL: 'normgiftpop', // （普通/安慰礼包领取弹窗）
  };
  const userOrderInfo = userOrderService.getUserOrderInfo();
  const gameOpenId = currentUrlParams.getCurrentParams('openid') || session.getSessionData().token;
  const mobile = userOrderInfo.orderMobile || '';
  report('act_extwechat_skip', {
    mobile,
    pageModule: TYPE_MAP[type.toUpperCase()],
    openId: gameOpenId,
  });
  adapter.openWechatMiniProgram({
    appName: 'benefit',
    path: 'pages/user/login',
    query: `from=toImportGongzhonghao&gameOpenId=${gameOpenId}&mobile=${mobile}`,
    type: config.env,
  });
}
